import { FilterDropdown } from '@rocco/ui/filter-sort/components/filters-bar/FilterDropdown';
import { useFiltersContext } from '@rocco/ui/filter-sort/components/Filters';
import {
    isLocationFilterState,
    isMultipleValuesFilterState,
    isRangeFilterState,
    isSearchableListFilterState,
    isSingleValueFilterState,
} from '@rocco/ui/filter-sort/view-models/filter-state/filter-state';
import { FiltersConfigSection } from '@rocco/ui/filter-sort/types/filter-config-section';
import { FilterStates } from '@rocco/ui/filter-sort/view-models/filter-states';
import { FiltersBarElement } from '@rocco/ui/filter-sort/components/filters-bar/FiltersBarElement';

export const FiltersBar = () => {
    const { searchFilters } = useFiltersContext();
    const { config, filterStates } = searchFilters;
    return (
        <>
            {config.barFilters.map(
                filterSection =>
                    isDropdownVisible(filterSection, filterStates) && (
                        <FilterDropdown
                            key={`filter-${filterSection.title}`}
                            title={filterSection.title}
                            closeOnScroll={true}
                        >
                            <div
                                className="flex flex-col gap-2 min-w-54"
                                style={
                                    filterSection.minContentWidth
                                        ? {
                                              minWidth: `${filterSection.minContentWidth}rem`,
                                          }
                                        : undefined
                                }
                            >
                                {filterSection.filters.map(filterConfigItem => (
                                    <FiltersBarElement
                                        key={filterConfigItem.filterKey}
                                        filterConfigItem={filterConfigItem}
                                        filterState={
                                            filterStates.states[
                                                filterConfigItem.filterKey
                                            ] ?? null
                                        }
                                    />
                                ))}
                            </div>
                        </FilterDropdown>
                    ),
            )}
        </>
    );
};

const isDropdownVisible = (
    filterSection: FiltersConfigSection,
    filterStates: FilterStates,
): boolean => {
    return filterSection.filters.some(filterConfigItem => {
        const filterState =
            filterStates.states[filterConfigItem.filterKey] ?? null;

        if (filterState) {
            if (isLocationFilterState(filterState)) {
                return true;
            }

            if (isSingleValueFilterState(filterState)) {
                return (filterState.count ?? 0) > 0;
            }

            if (isSearchableListFilterState(filterState)) {
                return true;
            }

            if (isMultipleValuesFilterState(filterState)) {
                return (
                    filterState.items.length > 0 ||
                    filterState.selectedItems.length > 0
                );
            }

            if (isRangeFilterState(filterState)) {
                const { min, max } = filterState.range;

                return (min !== 0 || max !== 0) && min < max;
            }
        }

        return false;
    });
};
